<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('FinanceManage.DesignSubaccounts')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="480px"
  >
    <el-form v-model="form" label-width="120px">
      <span v-show="isStep1">
        <el-form-item>
          <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PleaseSelectVoucherGroupingRule') }}</span>
          <el-select
            v-model="form.accountingDocumentRuleUuid"
            style="width: 200px;"
            @change="checkAvailableEntryTypes"
          >
            <el-option
              v-for="(item, index) in accountingDocumentRules"
              :key="index"
              :value="item.uuid"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_PSGROJE') }}</span>
          <el-select v-model="form.entryRuleUuid" style="width: 200px;">
            <el-option
              v-for="(item, index) in entryRules"
              :key="index"
              :value="item.uuid"
              :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_AccountTitleName')">
          <el-input v-model="form.ruleName" style="width: 200px;" :placeholder="$t('CargoMsg.Cargo_AutomaticGenerated')" />
        </el-form-item>
      </span>
      <span v-show="!isStep1">
        <span style="margin: 0 10px 0 10px">{{ $t('CargoMsg.Cargo_Name') }}</span>
        <el-input v-model="form.name" style="width: 120px;" />
        <span style="margin: 0 10px 0 10px">{{ $t('CargoMsg.Cargo_Coding') }}</span>
        <el-input v-model="form.code" style="width: 120px;" />
        <div class="app-main-inner-row row-grid" style="padding: 8px 8px 0 8px">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            min-height="300px"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </span>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="isStep1" type="primary" @click="nextStepHandler">{{ $t('common.btn.next') }}</el-button>
      <el-button v-else type="primary" @click="saveHandler">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="closeHandler(null)">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import FinanceUtil from '@/utils/FinanceUtil'
import * as accountingEntryRuleApi from '@/api/financeManage/accountingEntryRule'
import * as financeCodeMappingApi from '@/api/financeManage/financeCodeMapping'
import * as entryAccountTitleApi from '@/api/financeManage/entryAccountTitle'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor/index'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { User } from '@/class/model/sys/User'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getBankAccountList } from '@/api/bankAccount'
import ColumnUtils from '@/utils/ColumnUtils'
import DateUtils from '@/utils/dateUtils'
import { getDepartmentByOfficeId } from '@/api/user'
import $store from '@/store'
import { cache, cacheName } from '@/utils/cacheManager'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { isNumber2 } from '@/utils/validate'
import { DIMENSION_TAX_NATURE } from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'EntryAccountDialog',
  props: {
    visible: { type: Boolean, require: true },
    subAccountItem: { type: Object, default: null },
    entrySummaryRule: { type: Object, default: null },
    accountSet: { type: Object, default: null },
    entryRule: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      accountingDocumentRules: [],
      entryRules: [],
      entryRuleUuid: '',
      isStep1: true,
      form: {
        accountingDocumentRuleUuid: '',
        entryRuleUuid: '',
        ruleName: '',
        name: '',
        code: '',
        level: 1
      },
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor
        }
      },
      rowData: [],
      entryAccountTitle: null,
      accountingEntryRule: null,
      sales: [],
      allDepartments: [],
      settleDepartments: [],
      bankAccounts: []
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BasisForGrouping'),
          field: 'groupingDimension',
          width: 130,
          cellRenderer: params => {
            return FinanceUtil.entryGroupingDimensionLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'operator',
          width: 100,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            options: Array.from(FinanceInterfaceConstants.OPERATIONS),
            tagName: this.isZh ? 'chineseName' : 'englishName',
            tagValue: 'code'
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          },
          valueFormatter: params => {
            return FinanceUtil.operationLabelFunc(params.data.operator)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Value'),
          field: 'groupingValue',
          width: 160,
          editable: true,
          cellEditorSelector: this.cellEditorSelectorHandler,
          // 值变化事件
          onCellValueChanged: (params) => {
            console.log(params)
            this.onCellChange(params)
          },
          valueFormatter: this.valueFormatterHandler
        }
      ]
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        if (!this.accountingEntryRule) {
          this.initPage1()
          this.isStep1 = true
        }
        if (this.subAccountItem) {
          this.initPage2()
          this.isStep1 = false
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.loadAccountingDocumentRules(this.accountSet)
    this.sales = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => res.data)
    this.allDepartments = await getDepartmentByOfficeId(this.$store.getters.currentOfficeId).then(res => res.data)
    this.settleDepartments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, item => {
      return item.officeUuid === this.$store.getters.currentOfficeUuid && item.jobNoPrefix && item.clearing
    })
  },
  methods: {
    async loadAccountingDocumentRules(accountSet) {
      if (!accountSet.accountingDocumentRule || accountSet.accountingDocumentRule.length === 0) {
        const accountingDocumentRules = this.accountSet.accountingDocumentsRule // await accountingDocumentsRuleApi.query({ accountSetUuid: accountSet.uuid }).then(resp => resp.data.list)
        for (const rule of accountingDocumentRules) {
          rule.name = this.bizTypeDDLLabelFun(rule)
        }
        accountSet.accountingDocumentRule = accountingDocumentRules
      }
      return accountSet.accountingDocumentRule
    },
    async loadAccountingEntryRule(ruleUuid, accountSetUuid, entryType) {
      const params = {}
      params.accountingDocumentRuleUuid = ruleUuid
      params.accountSetUuid = accountSetUuid
      params.entryType = entryType
      return await accountingEntryRuleApi.query(params).then(resp => resp.data.list)
    },
    async saveHandler() {
      // todo 收费项目数组需转成英文逗号拼接的字符串，待多选框报错修复后处理
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (await this.validate(selectedRows)) {
        let subAccountItem = this.subAccountItem
        if (!this.subAccountItem) subAccountItem = this.entryAccountTitle.subAccountItem[0]
        subAccountItem.name = this.form.name
        subAccountItem.code = this.form.code
        subAccountItem.entryGroupingCriteria = selectedRows
        if (!this.subAccountItem) {
          this.entryAccountTitle.subAccountItem[0] = subAccountItem
        } else {
          const index = this.entryAccountTitle.subAccountItem.findIndex(item => item.uuid === subAccountItem.uuid)
          if (index > -1) {
            this.entryAccountTitle.subAccountItem[index] = subAccountItem
          } else {
            this.entryAccountTitle.subAccountItem.push(subAccountItem)
          }
        }
        this.updateNameCode(this.entryAccountTitle)
        // ---------------------
        const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, this.entryAccountTitle.entryType)
        if (!this.accountSet.financeCodeMapping || this.accountSet.financeCodeMapping.length === 0) {
          this.accountSet.financeCodeMapping = await financeCodeMappingApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
        }
        const entryCode = FinanceUtil.getMappingCode(this.accountSet, FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code, this.accountingEntryRule.entryType.toString())
        if (!this.entryAccountTitle.name) {
          const stateName = (state == null ? '' : state.chineseName)
          if (stateName.length > 0) {
            if (this.entryAccountTitle.name.length > 0) {
              this.entryAccountTitle.name = '-' + this.entryAccountTitle.name
            }
            this.entryAccountTitle.name = stateName + this.entryAccountTitle.name
          }
        }
        this.entryAccountTitle.code = entryCode !== undefined && entryCode ? entryCode + this.entryAccountTitle.code : this.entryAccountTitle.code
        const loading = getLoading()
        await entryAccountTitleApi.save(this.entryAccountTitle).then(resp => {
          this.closeHandler(resp.data)
        }).finally(() => loading.close())
      }
    },
    async checkAvailableEntryTypes() {
      const rule = this.accountingDocumentRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      if (rule && !rule.accountingEntryRule) {
        rule.accountingEntryRule = await this.loadAccountingEntryRule(rule.uuid, this.accountSet.uuid)
      }
      rule.accountingEntryRule.forEach(rule => { rule.name = this.entryRuleLabelFunc(rule) })
      this.entryRules = rule.accountingEntryRule
      this.form.entryRuleUuid = ''
    },
    entryRuleLabelFunc(accountingEntryRule) {
      if (accountingEntryRule) {
        const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, accountingEntryRule.entryType)
        if (state) {
          return state.chineseName
        }
      }
      return ''
    },
    bizTypeDDLLabelFun(rule) {
      const state = CommonState.getStateByCode(FinanceInterfaceConstants.BIZ_DATA_TYPES, rule.businessDataType)
      let label = state == null ? '' : state.chineseName
      if (label && rule.accountingMode && rule.accountingMode === FinanceInterfaceConstants.MODE_HEDGE.code) {
        label += '(' + FinanceInterfaceConstants.MODE_HEDGE.chineseName + ')'
      }
      return label
    },
    async nextStepHandler() {
      if (!this.form.accountingDocumentRuleUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucherGroupingRule'))
        return
      }
      if (!this.form.entryRuleUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PSGROJE'))
        return
      }
      this.isStep1 = false
      const documentRule = this.accountingDocumentRules.find(rule => rule.uuid === this.form.accountingDocumentRuleUuid)
      const entryRule = this.entryRules.find(rule => rule.uuid === this.form.entryRuleUuid)
      const entryAccountTitle = {}
      entryAccountTitle.businessDataType = documentRule.businessDataType
      entryAccountTitle.entryType = entryRule.entryType
      entryAccountTitle.accountSetUuid = this.accountSet.uuid
      entryAccountTitle.subAccountItem = []

      if (entryRule.entrySeries > 0) {
        const subAccountItem = {}
        subAccountItem.grade = this.form.level
        entryAccountTitle.subAccountItem.push(subAccountItem)
      } else {
        const state = CommonState.getStateByCode(FinanceInterfaceConstants.ENTRY_TYPES, entryRule.entryType)
        if (!this.accountSet.financeCodeMapping || this.accountSet.financeCodeMapping.length === 0) {
          this.accountSet.financeCodeMapping = await financeCodeMappingApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
        }
        const entryCode = FinanceUtil.getMappingCode(this.accountSet, FinanceInterfaceConstants.MAPPING_ACCOUNTING_ENTRY.code, entryRule.entryType.toString())
        entryAccountTitle.name = state == null ? '' : state.chineseName
        entryAccountTitle.code = entryCode
      }
      if (this.form.ruleName && this.form.ruleName.trim().length > 0) {
        entryAccountTitle.name = this.form.ruleName
      }
      this.accountingEntryRule = entryRule
      this.entryAccountTitle = entryAccountTitle
      this.buildDataSource()
    },
    async validate(saveList) {
      if ((!this.form.name || !this.form.name.trim()) && this.rowData.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterName'))
        return false
      } else if ((!this.form.code || !this.form.code.trim()) && this.rowData.length > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCode'))
        return false
      }
      for (const criteria of saveList) {
        if (!criteria.operator || !criteria.operator.trim()) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterOperationCode'))
          return false
        } else if (criteria.groupingValue === undefined || criteria.groupingValue.toString().trim().length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterValueOfCondition'))
          return false
        } else if (criteria.groupingDimension === FinanceInterfaceConstants.DIMENSION_CHARGE_GROUP.code && criteria.groupingValue.toString().trim().length !== 0) {
          const param = {}
          param.anyInteger = this.accountingEntryRule.entryType
          param.anyInteger1 = this.accountingEntryRule.businessDataType
          param.anyStr = criteria.groupingValue
          param.anyStr1 = this.accountingEntryRule.accountSetUuid
          param.anyStr2 = criteria.uuid
          const chargeGroupUuids = await entryAccountTitleApi.checkChargeGroup(param).then(res => res.data)
          if (chargeGroupUuids) {
            // 验证费用组,同一【凭证分组类型+数据类型】费用组不能重复
            const chargeGroupLabel = []
            for (const chargeGroupUuid of chargeGroupUuids.split(',')) {
              chargeGroupLabel.push(ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeGroup, 'uuid', chargeGroupUuid, $store.getters.language === 'zh' ? 'name' : 'englishName'))
            }
            this.$message.warning(this.$t('CargoMsg.Cargo_ChargeGroupCheck', [chargeGroupLabel.join(',')]))
            return false
          }
        }
      }
      return true
    },
    async initPage1() {
      this.accountingDocumentRules = await this.loadAccountingDocumentRules(this.accountSet)
      this.form.ruleName = ''
      this.form.level = 1
    },
    async initPage2() {
      const list = await entryAccountTitleApi.query({ accountSetUuid: this.accountSet.uuid, uuid: this.subAccountItem.entryAccountTitleUuid }).then(resp => resp.data.list)
      if (list && list.length > 0) {
        this.entryAccountTitle = list[0]
      }
      const entryAccountTitle = this.entryAccountTitle
      const entryType = entryAccountTitle.entryType
      // CARGO-7400，相同的凭证分组规则。存在不同凭证分组规则，维护了相同的分录分组规则
      // let accountingEntryRule
      // const accountingDocumentRules = await this.loadAccountingDocumentRules(this.accountSet)
      // for (const documentRule of accountingDocumentRules) {
      //   accountingEntryRule = await this.loadAccountingEntryRule(documentRule.uuid, this.accountSet.uuid, entryType)
      //   if (accountingEntryRule && accountingEntryRule.length > 0) {
      //     break
      //   }
      // }
      // if (!accountingEntryRule || accountingEntryRule.length === 0) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_IPCTFATROJE'))
      //   return
      // }
      if (this.entryRule === null) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IPCTFATROJE'))
        return
      }
      this.accountingEntryRule = this.entryRule
      this.form.name = this.subAccountItem.name
      this.form.code = this.subAccountItem.code

      this.buildDataSource()
    },
    async buildDataSource() {
      this.rowData = []
      // const start = this.getHighGradeCriterias()
      // for (let i = start; i < this.accountingEntryRule.entrySeries; i++) {
      //   const index = i - start
      //   let criteria
      //   if (this.subAccountItem && this.subAccountItem.entryGroupingCriteria && this.subAccountItem.entryGroupingCriteria.length > index) {
      //     criteria = this.subAccountItem.entryGroupingCriteria[index]
      //     criteria.selected = true
      //   } else {
      //     criteria = {}
      //     criteria.selected = false
      //     criteria.groupingDimension = this.accountingEntryRule['groupingDimension' + i]
      //   }
      //   this.rowData.push(criteria)
      // }
      for (let i = 1; i <= 6; i++) {
        const groupingDimension = this.accountingEntryRule['groupingDimension' + i]
        if (groupingDimension > 0) {
          let criteria = {}
          criteria.selected = false
          criteria.groupingDimension = groupingDimension
          if (this.subAccountItem && this.subAccountItem.entryGroupingCriteria && this.subAccountItem.entryGroupingCriteria.length > 0) {
            for (const criteria2 of this.subAccountItem.entryGroupingCriteria) {
              if (criteria2.groupingDimension == criteria.groupingDimension) {
                criteria = criteria2
                criteria.selected = true
                break
              }
            }
          }
          this.rowData.push(criteria)
        }
      }
      this.$nextTick(() => {
        // 选中标记项
        const nodes = this.gridOptions.api.getRenderedNodes()
        for (const node of nodes) {
          if (node && node.data && node.data.selected) {
            node.setSelected(true)
          }
        }
      })
    },
    // 获取比当前子科目级别高的条件数
    getHighGradeCriterias() {
      let count = 1
      for (const subItem of this.entryAccountTitle.subAccountItem) {
        if (this.subAccountItem && subItem.grade < this.subAccountItem.grade) {
          count += subItem.entryGroupingCriteria ? subItem.entryGroupingCriteria.length : 0
        }
      }
      return count
    },
    updateNameCode(entryAccountTitle) {
      let name = ''
      let code = ''
      const subAccountItems = entryAccountTitle.subAccountItem
      subAccountItems.sort((a, b) => {
        if (a.grade > b.grade) {
          return 1
        } else if (a.grade === b.grade) {
          return 0
        } else {
          return -1
        }
      })
      for (const sub of subAccountItems) {
        if (name.length > 0 && sub.name && sub.name.trim().length > 0) {
          name += '-'
        }
        name += sub.name
        code += sub.code
      }
      this.entryAccountTitle.name = name
      this.entryAccountTitle.code = code
    },
    closeHandler(params) {
      this.innerVisible = false
      if (params) {
        this.$emit('close', params)
      } else {
        this.$emit('close')
      }
      this.isStep1 = true
      this.form.name = ''
      this.form.code = ''
      this.form.accountingDocumentRuleUuid = ''
      this.form.entryRuleUuid = ''
      this.form.ruleName = ''
      this.rowData = []
      this.entryAccountTitle = {}
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.waitDealStatus = 'edit'
      }
      const field = params.field || params.colDef.field
      if (params.data.groupingDimension === FinanceInterfaceConstants.DIMENSION_CHARGE_ITEM.code ||
        params.data.groupingDimension === FinanceInterfaceConstants.DIMENSION_ACCOUNT.code ||
        params.data.groupingDimension === FinanceInterfaceConstants.DIMENSION_CHARGE_GROUP.code) {
        params.data.groupingValue = params.data.groupingValue ? params.data.groupingValue.join(',') : ''
      }
      if (field === 'groupingValue') {
        if (params.data.groupingDimension === FinanceInterfaceConstants.DIMENSION_TAX_RATE.code) { // 分组条件等于税率, 值必须是数字
          const newValue = params.newValue
          const oldValue = params.oldValue || ''
          if (newValue && !isNumber2(newValue)) {
            if (oldValue && isNumber2(oldValue)) {
              params.data.groupingValue = oldValue
            } else {
              params.data.groupingValue = ''
            }
            node.setDataValue('groupingValue', oldValue)
            this.$message.warning(this.$t('CargoMsg.Cargo_GroupingDimensionForRate'))
          }
        }
      }
    },
    cellEditorSelectorHandler(params) {
      const groupingDimension = params.data.groupingDimension
      const groupingValue = params.data.groupingValue
      switch (groupingDimension) {
        case FinanceInterfaceConstants.DIMENSION_BIZ_TYPE.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: Array.from(SystemConstants.FBA_LOBS),
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_DEPARTMENT.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: this.allDepartments,
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'departmentId'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_SALES.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: 'chineseName',
                selectType: TYPE_NAMES.basic_data_User,
                methodParams: { category: 'role', shape: 'sales' },
                callbackParams: { key: 'userId' },
                callbackMethodType: 'value'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_MBL.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_HBL.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_JOB_NO.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_BUSINESS_DATE.code:
          return {
            component: 'CargoAgGridDateTimeEditor',
            params: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_ACCOUNT.code:
          /* return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: 'chineseName',
                selectType: TYPE_NAMES.basic_data_Company,
                callbackParams: { key: 'accountId' },
                callbackMethodType: 'value'
              }
            }
          }*/
          // CARGO-53824, 凭证科目映射时结算对象条件选择【等于/不等于】时支持多选
          const arrAccount = []
          if (groupingValue) {
            const ids = (groupingValue instanceof Array) ? groupingValue : groupingValue.split(',')
            for (const id of ids) {
              if (!isNaN(Number(id))) arrAccount.push(Number(id))
            }
          }
          params.data.groupingValue = arrAccount
          return {
            component: 'CargoAgGridAdvanceMultipleSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                multiple: true,
                tagName: 'chineseName',
                tagValue: 'cmpIdx',
                defaultMultipleValue: arrAccount,
                selectType: TYPE_NAMES.basic_data_Company
              },
              value: arrAccount
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CUSTOMER.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: 'chineseName',
                selectType: TYPE_NAMES.basic_data_Company,
                methodParams: { customer: true },
                callbackParams: { key: 'accountId' },
                callbackMethodType: 'value'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INVOICE_NO.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_FINANCIAL_DATE.code:
          return {
            component: 'CargoAgGridDateTimeEditor',
            params: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CURRENCY.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagValue: 'code',
                tagName: 'code',
                selectType: TYPE_NAMES.basic_data_Currency,
                callbackParams: { key: 'currency' },
                callbackMethodType: 'value'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_VESSEL_VOYAGE.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_LOADING_PORT.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_DESTINATION_PORT.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CARGO_SOURCE.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: Array.from(SystemConstants.CARGO_SOURCES),
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_BANK_ACCOUNT.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagValue: 'accountNo',
                tagName: 'accountNo',
                staticOptions: this.bankAccounts,
                filterType: 'global',
                filterTagNames: ['accountNo', 'bankChineseName', 'bankEnglishName'],
                customLabel: (item) => `${item.bankChineseName}-${item.accountNo}`,
                showCustomLabelInOption: true
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INTERNAL_EXTERNAL.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_Internal'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_External'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CHARGE_ITEM.code :
          // todo 多选下拉框点击选中项时报错，待处理
          const arr = []
          if (groupingValue) {
            const ids = (groupingValue instanceof Array) ? groupingValue : groupingValue.split(',')
            for (const id of ids) {
              if (!isNaN(Number(id))) arr.push(Number(id))
            }
          }
          params.data.groupingValue = arr
          return {
            component: 'CargoAgGridAdvanceMultipleSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: 'zhName',
                tagValue: 'itemId',
                multiple: true,
                defaultMultipleValue: arr,
                selectType: TYPE_NAMES.basic_data_ChargeItem
              },
              value: arr
            }
          }

        case FinanceInterfaceConstants.DIMENSION_DUTY_FREE.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_DutyFree'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_NotTaxFree'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_TAX_RATE.code:
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_ACCOUNTING_CARRYOVER.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_NotCarriedOver'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_CarriedOver'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INVOICE_TYPE.code :
          const invoiceTypes = [
            { name: this.$t('CargoMsg.Cargo_GeneralInvoice'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_SpecialInvoice'), code: 1 },
            { name: this.$t('CargoMsg.Cargo_VatGeneralInvoice'), code: 2 },
            { name: this.$t('CargoMsg.Cargo_VatSpecialInvoice'), code: 3 },
            { name: this.$t('CargoMsg.Cargo_InternalInvoice'), code: 4 }
          ]
          const interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
          const toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
          if (interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || toExoSystemYGSH) {
            invoiceTypes.push({ name: this.$t('CargoMsg.Cargo_VAT_FEI'), code: 6 })
            invoiceTypes.push({ name: this.$t('CargoMsg.Cargo_NORMAL_FEI'), code: 7 })
          }
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: invoiceTypes,
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CONTAINERLOAD_TYPE.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: Array.from(SystemConstants.CONTAINERLOAD_TYPES),
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INTERNAL_PARTNER.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_No'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_Yes'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INTERNAL_OVERSEA.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              selectProps: {
                clearable: true
              },
              options: [
                { name: this.$t('SeaExport.internal'), code: '0' },
                { name: this.$t('SeaExport.overseas'), code: '1' }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_SETTLE_DEPARTMENT.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              selectProps: {
                clearable: true
              },
              options: this.settleDepartments,
              tagName: 'chineseName',
              tagValue: 'jobNoPrefix'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_RECEIVE_DUTY_FREE.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_DutyFree'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_NotTaxFree'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_BILLPAYMENT_INPUTBY.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: 'chineseName',
                selectType: TYPE_NAMES.basic_data_User,
                methodParams: { category: 'role', shape: 'sales' },
                callbackParams: { key: 'userId' },
                callbackMethodType: 'value'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CHARGE_GROUP.code:
          const chargeGroups = groupingValue ? groupingValue.split(',') : []
          params.data.groupingValue = chargeGroups
          return {
            component: 'CargoAgGridAdvanceMultipleSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                tagName: this.isZh ? 'name' : 'englishName',
                tagValue: 'uuid',
                multiple: true,
                defaultMultipleValue: chargeGroups,
                selectType: TYPE_NAMES.basic_data_ChargeGroup
              },
              value: chargeGroups
            }
          }

        case FinanceInterfaceConstants.DIMENSION_RECEIVE_ALL_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CURRENCY_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CHARGE_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CHARGE.code :
        case FinanceInterfaceConstants.DIMENSION_PAYABLE_ALL_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_HAS_INVOICE_NO.code :
        case FinanceInterfaceConstants.DIMENSION_IF_OPERATING_COST.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_ADJUSTMENT.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_ADVANCE.code :
        case FinanceInterfaceConstants.DIMENSION_PRERECEIPT_TAX.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_NAME_JOB_NO_CUSTOMER.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_JOB_NO.code :
        case FinanceInterfaceConstants.DIMENSION_ADVANCE_JOB_NO.code :
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: [
                { name: this.$t('CargoMsg.Cargo_No'), code: 0 },
                { name: this.$t('CargoMsg.Cargo_Yes'), code: 1 }
              ],
              tagName: 'name',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_ATD.code:
        case FinanceInterfaceConstants.DIMENSION_ATA.code:
          return {
            component: 'CargoAgGridDateTimeEditor',
            params: {
              props: {
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                style: 'width: 100%'
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                selectType: TYPE_NAMES.basic_data_CutomJobType,
                methodParams: { active: true }
              }
            }
          }
        case FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code:
          return {
            component: 'CargoAgGridAdvanceSelectEditor',
            params: {
              selectProps: {
                filterable: true,
                selectType: TYPE_NAMES.basic_data_CargoInformation
              }
            }
          }

        case FinanceInterfaceConstants.DIMENSION_TAX_NATURE.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: Array.from(SystemConstants.TAX_NATURES),
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          }

        case FinanceInterfaceConstants.DIMENSION_INVOICE_NATURE.code:
          return {
            component: 'CargoAgGridSelectEditor',
            params: {
              options: Array.from(InvoiceConstant.INVOICE_NATURE),
              tagName: this.isZh ? 'chineseName' : 'englishName',
              tagValue: 'code'
            }
          }
        default :
          return {
            component: 'CargoAgGridCommonInputEditor',
            params: {
              inputProps: {
                style: 'width: 100%'
              }
            }
          }
      }
    },
    valueFormatterHandler(params) {
      const groupingDimension = params.data.groupingDimension
      const groupingValue = params.data.groupingValue
      let result
      switch (groupingDimension) {
        case FinanceInterfaceConstants.DIMENSION_BIZ_TYPE.code:
          return CommonState.getNameByCode(Array.from(SystemConstants.FBA_LOBS), groupingValue)

        case FinanceInterfaceConstants.DIMENSION_DEPARTMENT.code:
          if (!this.allDepartments) {
            this.allDepartments = getCacheListByKey(basicCacheKeys.basic_data_Department_All)
          }
          result = this.allDepartments.find(dep => dep.departmentId === Number(groupingValue))
          return result ? result.chineseName : ''

        case FinanceInterfaceConstants.DIMENSION_SALES.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(groupingValue), 'chineseName')

        case FinanceInterfaceConstants.DIMENSION_MBL.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_HBL.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_JOB_NO.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_BUSINESS_DATE.code:
          return DateUtils.customFormat(groupingValue, 'YYYY-MM-DD')

        case FinanceInterfaceConstants.DIMENSION_ACCOUNT.code:
          // return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(groupingValue), 'chineseName')
          let valueAccount = ''
          if (groupingValue) {
            const ids = (groupingValue instanceof Array) ? groupingValue : groupingValue.split(',')
            for (const id of ids) {
              if (valueAccount) {
                valueAccount += ','
              }
              valueAccount += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(id), 'chineseName')
            }
          }
          return valueAccount

        case FinanceInterfaceConstants.DIMENSION_CUSTOMER.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(groupingValue), 'chineseName')

        case FinanceInterfaceConstants.DIMENSION_INVOICE_NO.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_FINANCIAL_DATE.code:
          return DateUtils.customFormat(groupingValue, 'YYYY-MM-DD')

        case FinanceInterfaceConstants.DIMENSION_CURRENCY.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Currency, 'code', groupingValue, 'code')

        case FinanceInterfaceConstants.DIMENSION_VESSEL_VOYAGE.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_LOADING_PORT.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_DESTINATION_PORT.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_CARGO_SOURCE.code:
          return CommonState.getNameByCode(Array.from(SystemConstants.CARGO_SOURCES), groupingValue)

        case FinanceInterfaceConstants.DIMENSION_BANK_ACCOUNT.code:
          if (this.bankAccounts) {
            result = this.bankAccounts.find(account => account.accountNo === String(groupingValue))
          }
          return result ? result.bankChineseName : ''
        case FinanceInterfaceConstants.DIMENSION_INTERNAL_EXTERNAL.code :
          result = [{ name: this.$t('CargoMsg.Cargo_Internal'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_External'), code: 1 }].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_CHARGE_ITEM.code :
          let value = ''
          if (groupingValue) {
            const ids = (groupingValue instanceof Array) ? groupingValue : groupingValue.split(',')
            for (const id of ids) {
              if (value) {
                value += ','
              }
              value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(id), 'zhName')
            }
          }
          return value

        case FinanceInterfaceConstants.DIMENSION_DUTY_FREE.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_DutyFree'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_NotTaxFree'), code: 1 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_TAX_RATE.code:
          return groupingValue

        case FinanceInterfaceConstants.DIMENSION_ACCOUNTING_CARRYOVER.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_NotCarriedOver'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_CarriedOver'), code: 1 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_INVOICE_TYPE.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_GeneralInvoice'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_SpecialInvoice'), code: 1 },
            { name: this.$t('CargoMsg.Cargo_VatGeneralInvoice'), code: 2 },
            { name: this.$t('CargoMsg.Cargo_VatSpecialInvoice'), code: 3 },
            { name: this.$t('CargoMsg.Cargo_InternalInvoice'), code: 4 },
            { name: this.$t('CargoMsg.Cargo_VAT_FEI'), code: 6 },
            { name: this.$t('CargoMsg.Cargo_NORMAL_FEI'), code: 7 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_CONTAINERLOAD_TYPE.code :
          return CommonState.getNameByCode(Array.from(SystemConstants.CONTAINERLOAD_TYPES), groupingValue)

        case FinanceInterfaceConstants.DIMENSION_INTERNAL_PARTNER.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_No'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_Yes'), code: 1 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_INTERNAL_OVERSEA.code :
          result = [
            { name: this.$t('SeaExport.internal'), code: '0' },
            { name: this.$t('SeaExport.overseas'), code: '1' }
          ].find(opt => opt.code === groupingValue)
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_SETTLE_DEPARTMENT.code:
          if (!this.settleDepartments) {
            this.settleDepartments = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Department, item => {
              return item.officeUuid === this.$store.getters.currentOfficeUuid && item.jobNoPrefix && item.clearing
            })
          }
          result = this.settleDepartments.find(dep => dep.jobNoPrefix === groupingValue)
          return result ? result.chineseName : ''

        case FinanceInterfaceConstants.DIMENSION_RECEIVE_DUTY_FREE.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_DutyFree'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_NotTaxFree'), code: 1 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_BILLPAYMENT_INPUTBY.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(groupingValue), 'chineseName')

        case FinanceInterfaceConstants.DIMENSION_CHARGE_GROUP.code:
          let chargeGroupValue = ''
          if (groupingValue) {
            const uuids = (groupingValue instanceof Array) ? groupingValue : groupingValue.split(',')
            for (const chargeGroupUuid of uuids) {
              if (chargeGroupValue) {
                chargeGroupValue += ','
              }
              chargeGroupValue += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeGroup, 'uuid', chargeGroupUuid, $store.getters.language === 'zh' ? 'name' : 'englishName')
            }
          }
          return chargeGroupValue

        case FinanceInterfaceConstants.DIMENSION_RECEIVE_ALL_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CURRENCY_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CHARGE_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_RECEIVE_SAME_CHARGE.code :
        case FinanceInterfaceConstants.DIMENSION_PAYABLE_ALL_INVOICED.code :
        case FinanceInterfaceConstants.DIMENSION_HAS_INVOICE_NO.code :
        case FinanceInterfaceConstants.DIMENSION_IF_OPERATING_COST.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_ADJUSTMENT.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_ADVANCE.code :
        case FinanceInterfaceConstants.DIMENSION_PRERECEIPT_TAX.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_NAME_JOB_NO_CUSTOMER.code :
        case FinanceInterfaceConstants.DIMENSION_CHARGE_JOB_NO.code :
        case FinanceInterfaceConstants.DIMENSION_ADVANCE_JOB_NO.code :
          result = [
            { name: this.$t('CargoMsg.Cargo_No'), code: 0 },
            { name: this.$t('CargoMsg.Cargo_Yes'), code: 1 }
          ].find(opt => opt.code === Number(groupingValue))
          return result ? result.name : ''

        case FinanceInterfaceConstants.DIMENSION_ATD.code:
        case FinanceInterfaceConstants.DIMENSION_ATA.code:
          return DateUtils.customFormat(groupingValue, 'YYYY-MM-DD')

        case FinanceInterfaceConstants.DIMENSION_CUSTOM_JOB_TYPE.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', groupingValue, 'name')
        case FinanceInterfaceConstants.DIMENSION_CARGO_CATEGORY.code:
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', groupingValue, 'chineseName')
        case FinanceInterfaceConstants.DIMENSION_TAX_NATURE.code:
          result = SystemConstants.TAX_NATURES.find(opt => opt.code === Number(groupingValue))
          return result ? (this.isZh ? result.chineseName : result.englishName) : ''
        case FinanceInterfaceConstants.DIMENSION_INVOICE_NATURE.code:
          result = InvoiceConstant.INVOICE_NATURE.find(opt => opt.code === Number(groupingValue))
          return result ? (this.isZh ? result.chineseName : result.englishName) : ''
        default :
          return groupingValue
      }
    }
  }
}
</script>

<style scoped>

</style>
